// Redux slice quản lý khách hàng
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const fetchThanhToan = createAsyncThunk("thanhToan/fetchThanhToan", async (params = {}, { rejectWithValue }) => {
  try {
    const query = {
      size: params.size || 10,
      order: "id desc",
      page: params.page || 1,
      operating_unit_id: localStorage.getItem("selected_operating_unit_id"),
      search: params.search,
      date_gte: params.date_gte,
      date_lte: params.date_lte,
    };

    // chỉ thêm nếu payment_state  có giá trị khác ""
    if (params.payment_state !== "") {
      query.payment_state = params.payment_state;
    }
    const res = await api.get("/medeco.register.consultation/payment", { params: query });
    // Trả về cả content và totalElements để phân trang
    console.log("res res", res);
    return res.data;
  } catch (err) {
    console.log("err ", err);
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const fetchHoaDon = createAsyncThunk("thanhToan/fetchHoaDon", async (params = {}, { rejectWithValue }) => {
  try {
    const query = {
      size: params.size || 10,
      order: "id desc",
      page: params.page || 1,
      operating_unit_id: localStorage.getItem("selected_operating_unit_id"),
      search: params.search,
      date_gte: params.date_gte,
      date_lte: params.date_lte,
      move_type: "out_invoice",
    };

    // chỉ thêm nếu payment_state  có giá trị khác ""
    if (params.payment_state !== "") {
      query.payment_state = params.payment_state;
    }
    const res = await api.get("/account.move", { params: query });
    // Trả về cả content và totalElements để phân trang
    console.log("res res", res);
    return res.data;
  } catch (err) {
    console.log("err ", err);
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const updateThanhToan = createAsyncThunk("thanhToan/updateThanhToan", async (payload, { rejectWithValue }) => {
  try {
    // Parse int trước khi gửi lên API
    const data = {
      ...payload,
      amount_received: payload.amount_received != null ? parseInt(payload.amount_received) : payload.amount_received,
      journal_id: payload.journal_id != null ? parseInt(payload.journal_id) : payload.journal_id,
    };
    const res = await api.post(`/object/medeco.register.consultation/register_payment/${payload.id}`, { kwargs: data });
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const fetchPhuongThucThanhToan = createAsyncThunk("thanhToan/fetchPhuongThucThanhToan", async (params = {}, { rejectWithValue }) => {
  try {
    const res = await api.get("/account.payment/available_journal", {
      params: {
        size: params.size || 100,
        order: "id desc",
        page: params.page || 1,
        operating_unit_id: localStorage.getItem("selected_operating_unit_id"),
      },
    });
    return res.data || [];
  } catch (err) {
    console.log("err ", err);
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const fetchListCLS = createAsyncThunk("thanhToan/fetchListCLS", async (params = {}, { rejectWithValue }) => {
  try {
    const query = {
      size: params.size || 10,
      order: "id desc",
      page: params.page || 1,
      operating_unit_id: localStorage.getItem("selected_operating_unit_id"),
      search: params.search,
      date_gte: params.date_gte,
      date_lte: params.date_lte,
    };

    // chỉ thêm nếu service_state  có giá trị khác ""
    if (params.service_state !== "") {
      query.service_state = params.service_state;
    }
    const res = await api.get(`/medeco.register.consultation.service.line/cls/${params.id}`, { params: query });
    return res.data || [];
  } catch (err) {
    console.log("err ", err);
    return rejectWithValue(err.response?.data || err.message);
  }
});

const initialState = {
  items: { content: [], totalElements: 0, group_summary: {} },
  phuongThucThanhToans: [],
  hoadons: { content: [], totalElements: 0, group_summary: {} },
  cls: { content: [], totalElements: 0, group_summary: {} },
  loading: false,
  error: null,
};

const thanhToanSlice = createSlice({
  name: "thanhToan",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchThanhToan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchThanhToan.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchThanhToan.rejected, (state) => {
        state.loading = false;
        // state.error = action.payload;
      });
    // Update thanh toan
    builder.addCase(updateThanhToan.fulfilled, (state, action) => {
      const idx = state.items.content?.findIndex((d) => d.id === action.payload.id);
      if (idx > -1) state.items.content[idx] = { ...state.items.content[idx], ...action.payload };
    });

    // Get phuong thuc thanh toan
    builder.addCase(fetchPhuongThucThanhToan.fulfilled, (state, action) => {
      state.phuongThucThanhToans = action.payload;
    });

    // Fetch hoa don
    builder.addCase(fetchHoaDon.fulfilled, (state, action) => {
      state.hoadons = action.payload;
      state.loading = false;
    });

    // Fetch CLS
    builder.addCase(fetchListCLS.fulfilled, (state, action) => {
      state.cls = action.payload;
      state.loading = false;
    });
  },
});

export default thanhToanSlice.reducer;
